import "../../../node_modules/@vanilla-extract/webpack-plugin/vanilla.virtual.css?%7B%22fileName%22%3A%22components%2Fabstracts%2FInput%2Fstyles.css.ts.vanilla.css%22%2C%22source%22%3A%22Ll8xY21vcjg5MCB7CiAgYm9yZGVyLXJhZGl1czogMDsKfQ%3D%3D%22%7D"
export var Input = '_1cmor890';
export var Textarea = '_1cmor891';